module.exports = __webpack_public_path__ + "static/media/Stilt-Kin-Unselected.e5c87cc3.png";